import {InitPage} from "../../index";
import * as Toastr from "toastr";
import swal from "sweetalert";

declare var set_printer_url;
declare var notAddedItemsPath;

class ShippingShipments {
    constructor() {
        const _this = this;

        $('#bulk-print').on('click', function (e) {
            e.preventDefault();
            const selectedPrinter = $("#printer_id").val()
            if (selectedPrinter == '') {
                e.stopImmediatePropagation();
                Toastr.error("No printer selected", "Error");
            } else {
                const href = window.origin + $(this).attr("href");
                var url = new URL(href);
                let item_ids = [];
                $('.shipment_tag:checked').each(function () {
                    item_ids.push($(this).val());
                })

                if (item_ids.length !== 0) {
                    url.searchParams.set('shipment_items', item_ids.join(','));
                    $(this).prop("disabled", false);
                    $(this).attr("href", url.pathname + url.search);
                } else {
                    Toastr.error("No item selected", "Error");
                    $(this).prop("disabled", true);
                }
            }
        });

        $("#all_shipment_items").on('click', function (e) {
            const allCheckbox = $('#all_shipment_items').is(':checked');
            $('input[name*="shipment_items"]:enabled').prop('checked', allCheckbox);
        });

        $('.shipment_tag').on('click', function(e) {
            if(!$(this).is(':checked'))
            {
                $("#all_shipment_items").prop('checked', false)
            }
            else if ($('.shipment_tag:enabled').length === $('.shipment_tag:checked').length) {
                $('#all_shipment_items').prop('checked', true);
            }
        });

        $('.printRecord').on('click', function (e) {
            e.preventDefault();
            const selectedPrinter = $("#printer_id").val()
            if (selectedPrinter == '') {
                e.stopImmediatePropagation();
                Toastr.error("No printer selected", "Error");
            } else {
                var message = $(this).attr('data-print-message');
                swal({
                    title: 'Are you sure?',
                    text: message,
                    icon: "warning",
                    closeOnClickOutside: false,
                    buttons: {
                        cancel: {
                            text: "No",
                            value: null,
                            visible: true,
                            className: "sn-btn sn-btn-sm sn-btn-silver",
                            closeModal: true
                        },
                        confirm: {
                            text: "Yes",
                            value: true,
                            visible: true,
                            className: "sn-btn sn-btn-sm sn-btn-red",
                            closeModal: true
                        }
                    },
                    dangerMode: true,
                }).then((willPrint) => {
                    if (willPrint) {
                        var target = $(e.currentTarget).next();
                        target.click();
                    } else {
                        return false;
                    }
                });
            }
        });

        $('#printer_id').change(function () {
            $.ajax({
                url: set_printer_url,
                method: 'POST',
                data: {printer: $(this).val()}
            }).done(function (e) {
                console.log(e);
            })
        });


        $('.editBtn').on('click', function (e) {
            e.preventDefault();
            $("#commit i").removeClass('fa-plus-circle');
            $("#commit i").addClass('fa-save');
            $("#commit").removeAttr("disabled");
            $("#commit i").removeClass('text-gray');
            $("#commit i").addClass('text-success');
            const _anchor = this;
            let editPath = $(_anchor).data("edit-path");
            $.ajax({
                url: editPath,
                method: "get",
            }).then(response => {
                if ($('.item_number').find("option[value='" + response.item_number + "']").length) {
                    $('.item_number').val(response.item_number).trigger('change');
                } else {
                    var newOption = new Option(`${response.item_number}(${response.item_name})`, response.item_number, true, true);
                    $('.item_number').append(newOption).trigger('change');
                }
                $("#shipping_shipment_item_pallet_number").val(response.pallet_number);
                $("#shipping_shipment_item_cartons_count").val(response.cartons_count);
                $("#shipping_shipment_item_items_count").val(response.items_count);
                $("#shipping_shipment_item_uom").val(response.uom);
                $("#shipping_shipment_item_bin_number").val(response.bin_number);
                $("#shipment-item-form").attr("action", editPath.replace(/edit/g, ""));
                $("#location").val('step_2');
                $("#shipment-item-form").attr("method", 'patch');
                $("#form_method").val('patch');
            });
        });

        $('.editBtnInModal').on('click', function (e) {
            e.preventDefault();
            const _anchor = this;
            let editPath = $(_anchor).data("edit-path");
            $.ajax({
                url: editPath,
                method: "get",
            }).then(response => {
                $("#id").val(response.id);
                $("#item_number").val(response.item_number);
                $("#pallet_number").val(response.pallet_number);
                $("#cartons_count").val(response.cartons_count);
                $("#items_count").val(response.items_count);
                $("#uom").val(response.uom);
                $("#bin_number").val(response.bin_number);
                $('#status option[value=' + response.status + ']').attr('selected', 'selected');
                $("#location").val('show');
                $("#edit-shipment_item-form").modal('show');
                $('#shipping_shipment_item').attr('action', editPath.replace(/edit/g, ''));
                $("#shipping_shipment_item").attr("method", 'patch');
            });
        });

        $('#status').on('change', function () {
            $('#message').text('Please be cautious, if you change a shipment item status back to shipped the related tags will be killed.');

        })
    }

    initializeHTML() {
        const _this = this;
        $('.item_number').select2({
            placeholder: 'Search and Select Item',
            allowClear: true,
            ajax: {
                url: notAddedItemsPath
                },
            dropdownParent: $("#item-list"),
            templateSelection: _this.updateItemMetadata
          });

    }

    updateItemMetadata(e: any) {
        return e.text;
    }
}

declare global {
    interface Window {
        ShippingShipments: ShippingShipments;
    }
}

export function LoadPage() {
    InitPage("shipments", () => {
        const shipping_shipments = new ShippingShipments();
        window.ShippingShipments =  new ShippingShipments();
        window.ShippingShipments.initializeHTML();
    });
}
